import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const ProgressWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
`;
// border: 1px solid ${colors.lightGray};

export default ProgressWrapper;
